window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
$.ajaxSetup({headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}});
require('jquery-validation');
require('./home');
require('./routes');
require('slick-carousel');
const Plyr = require('plyr');

$(function () {
    const players = new Plyr('.player');
    $('.hb').on('click', function (e) {
        e.preventDefault();
        $('body').toggleClass('menu-open');
    });
    $('.block-faq .chevron').on('click', function (e) {
        $(this).next().click();
    });
    $('.question').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.block-faq').find('.answer').slideToggle();
        $(this).closest('.block-faq').toggleClass('active');
    });

    $('.slider').slick({
        dots: true,
        infinite: true,
    });

});
